(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dialcove-set-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dc-set-picker')) {
  customElements.define('dc-set-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('.dc-set-submit');
      this.error = this.querySelector('.dc-set-error');
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency', currency:this.dataset.currency || 'INR'});
      const requested = new URLSearchParams(location.search).get('set');
      if (['1','2','3'].includes(requested)) this.querySelector('input[value="' + requested + '"]').checked = true;
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', (event) => this.submit(event));
      this.update();
    }
    update() {
      this.count = Number(this.querySelector('input[name="dc_set_size"]:checked').value);
      const rate = this.count === 3 ? 15 : this.count === 2 ? 10 : 0;
      let subtotal = 0;
      let discount = 0;
      let available = true;
      const groups = new Map();
      this.querySelectorAll('[data-case]').forEach(row => {
        const active = Number(row.dataset.case) <= this.count;
        row.hidden = !active;
        const select = row.querySelector('select');
        select.disabled = !active;
        const option = select.selectedOptions[0];
        const img = row.querySelector('img');
        if (option && img) { img.src = option.dataset.image; img.removeAttribute('srcset'); img.alt = option.textContent.trim(); }
        if (active && (!option || option.disabled)) available = false;
        if (active && option) {
          const existing = groups.get(option.value) || {id:option.value, quantity:0, price:Number(option.dataset.price)};
          existing.quantity += 1;
          groups.set(option.value, existing);
        }
      });
      groups.forEach(item => { const line = item.price * item.quantity; subtotal += line; discount += Math.round(line * rate / 100); });
      this.querySelector('[data-total]').textContent = this.format.format((subtotal-discount)/100);
      const savings = this.querySelector('[data-savings]');
      savings.hidden = !discount;
      savings.textContent = this.dataset.save.replace('__AMOUNT__', this.format.format(discount/100));
      this.button.disabled = !available || this.busy === true;
      this.button.textContent = available ? (this.count === 1 ? this.dataset.single : this.dataset.set) : this.dataset.unavailable;
      this.items = [...groups.values()].map(({id,quantity}) => ({id,quantity}));
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy || this.button.disabled) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.adding;
      this.error.hidden = true;
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:this.items})});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        location.assign(this.dataset.cartUrl);
      } catch(error) {
        this.error.textContent = error.message || this.dataset.error;
        this.error.hidden = false;
        this.button.disabled = false;
        this.busy = false;
        this.update();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
